import React, { useContext } from 'react';
import { Text } from '@perch-labs/shrike';
import lighten from 'polished/lib/color/lighten';
import { percent } from '@perch-labs/warbler';
import { ThemeContext } from 'styled-components';
import { copyFor } from 'config';
import { Container, LegacyListItem, List } from 'styles';
import { energySourceLabelMap } from 'domain/usage';
import { Circle, Wrapper } from './energy-mix.style';

const getCopy = copyFor('usage.energyAnalysis.energyMix');

interface Props {
  sources: {
    coal: number;
    gas: number;
    nuclear: number;
    oil: number;
    renewables: number;
  };
}

export const EnergyMix = ({ sources }: Props) => {
  const theme = useContext(ThemeContext);
  if (!sources) return null;
  const { coal, gas, nuclear, oil, renewables } = sources;
  const other = 1 - (coal + gas + nuclear + oil + renewables);
  const mix = { coal, gas, nuclear, oil, other, renewables };

  return (
    <Wrapper>
      <Text textStyle="heading800" tag="h2" margin={{ bottom: '24px' }}>
        {getCopy('title1')} <span>{getCopy('title2')}</span>
      </Text>
      <List withBorders>
        {Object.keys(mix).map((key, index) => {
          return (
            <LegacyListItem data-testid="line-item" key={key}>
              <Container flex>
                <Circle
                  background={
                    key === 'renewables'
                      ? theme.colors.alternative1
                      : lighten(index * 0.1, theme.colors.content.secondary)
                  }
                />
                <Text textStyle="paragraph400" margin={{ left: '8px' }}>
                  {energySourceLabelMap[key]}
                </Text>
              </Container>
              <Text textStyle="paragraph400">{percent(mix[key], 1)}</Text>
            </LegacyListItem>
          );
        })}
      </List>
    </Wrapper>
  );
};
